/**
 * Constants Service - All timing values and magic numbers
 * Centralized location for all constants used across the Copilot feature
 */

// Timing constants (in milliseconds)
export const TIMING = {
  WELCOME_MESSAGE_DISPLAY_DURATION: 1000,
  VALIDATION_SUCCESS_DELAY: 3000,
} as const;

// Default labels for forms
export const DEFAULT_LABELS = {
  GENERAL: 'Application Details',
  CONNECTION: 'Connection Setup',
  CREATE_ACCOUNT: 'Create Account',
  UPDATE_ACCOUNT: 'Update Account',
  ENABLE_ACCOUNT: 'Enable Account',
  DISABLE_ACCOUNT: 'Disable Account',
  REMOVE_ACCOUNT: 'Remove Account',
} as const;

// Step names
export const STEP_NAMES = {
  GENERAL: 'General',
  CONNECTION: 'Connection',
  CREATE_ACCOUNT: 'CreateAccount',
  UPDATE_ACCOUNT: 'UpdateAccount',
  ENABLE_ACCOUNT: 'EnableAccount',
  DISABLE_ACCOUNT: 'DisableAccount',
  REMOVE_ACCOUNT: 'RemoveAccount',
  ADD_ACCESS: 'AddAccess',
  REMOVE_ACCESS: 'RemoveAccess',
} as const;

// Message types
export const MESSAGE_TYPES = {
  AI_RESPONSE: 'ai_response',
  USER_RESPONSE: 'user_response',
  STEP_FORM: 'step_form',
} as const;

// Message subtypes
export const MESSAGE_SUBTYPES = {
  START: 'start',
  SUCCESS: 'success',
  ERROR: 'error',
  BASIC_CONFIG: 'basic_config',
  CONNECTION_CONFIG: 'connection_config',
  CREATE_ACCOUNT_FORM: 'create_account_form',
  UPDATE_ACCOUNT_FORM: 'update_account_form',
  ENABLE_ACCOUNT_FORM: 'enable_account_form',
  DISABLE_ACCOUNT_FORM: 'disable_account_form',
  REMOVE_ACCOUNT_FORM: 'remove_account_form',
  ADD_ACCESS_FORM: 'add_access_form',
  REMOVE_ACCESS_FORM: 'remove_access_form',
} as const;

// Message IDs
export const MESSAGE_IDS = {
  WELCOME: 'welcome-message',
  FORM_GENERAL: 'form-general',
  FORM_CONNECTION: 'form-connection',
  FORM_CREATE_ACCOUNT: 'form-create-account',
} as const;
